"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmailAddress = exports.normalizedCompare = void 0;
const normalizedCompare = (a, b) => a.toLowerCase().trim() === b.toLowerCase().trim();
exports.normalizedCompare = normalizedCompare;
const isEmailAddress = (str) => /^[A-z0-9.! #$%&'*+\/=? ^_`{|}~-]+@[A-z0-9-]+(?:\.[A-z0-9-]+)*$/.test(str);
exports.isEmailAddress = isEmailAddress;
//# sourceMappingURL=email.js.map